import Vue from 'vue'
import {
  Button,
  ButtonGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Pagination,
  Menu,
  MenuItem,
  Submenu,
  Container,
  Header,
  Aside,
  Main,
  Col,
  Row,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Card,
  Loading,
  MessageBox,
  Message,
  Dialog,
  Icon,
  Cascader,
  Image,
  Upload,
  Badge,
  Avatar,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DatePicker,
  Autocomplete,
  Tree,
  CheckboxGroup,
  Checkbox,
  Collapse,
  CollapseItem,
  TimeSelect,
  TimePicker,
  Tooltip,
  Notification,
  Drawer,
  Progress,
  Slider,
  Popover,
  Switch,
  Steps,
  Step,
  Timeline,
  TimelineItem,
  Carousel,
  CarouselItem,
  InfiniteScroll,
  Link,
  Rate,
  InputNumber,
  Transfer,
  Empty,
  Tag,
  Divider,
  PageHeader
} from 'element-ui'

Vue.use(PageHeader)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Col)
Vue.use(Row)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Card)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Cascader)
Vue.use(Image)
Vue.use(Upload)
Vue.use(Badge)
Vue.use(Avatar)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(DatePicker)
Vue.use(Autocomplete)
Vue.use(Tree)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Tooltip)
Vue.use(Drawer)
Vue.use(RadioButton)
Vue.use(Progress)
Vue.use(Slider)
Vue.use(Popover)
Vue.use(Switch)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(InfiniteScroll)
Vue.use(Loading.directive)
Vue.use(Link)
Vue.use(Rate)
Vue.use(InputNumber)
Vue.use(Transfer)
Vue.use(Tag)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }

const messages = ['success', 'warning', 'info', 'error']
messages.forEach((item: any) => {
  Vue.prototype.$message[item] = (msg: any) => {
    return Message({
      message: msg,
      duration: 1000,
      type: item
    })
  }
})
